module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['single', {
      'is-hidden': _vm.singleIsHidden
    }]
  }, [_c('single-header', {
    attrs: {
      "project": _vm.project
    }
  }, [_c('p', [_vm._v("It explains what Artificial Intelligence is and where we can\n        already use it for medical purposes, military operations, self-driving cars\n        and research in outer space.\n        The lovely robot drawings are made by the talented artist\n        "), _c('a', {
    attrs: {
      "href": "http://luniciasminion.deviantart.com/",
      "target": "_blank"
    }
  }, [_vm._v("Jennifer Koch")]), _vm._v(".")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "info": "",
      "color": _vm.project.color,
      "header": "1st Place in Digital Media Contest"
    }
  }, [_c('p', [_vm._v("This project reached 1st place in a digital media contest organized by the\n        parliament of Baden-Württemberg, South Germany in 2016 for educational purposes.")])]), _vm._v(" "), _c('single-section', {
    attrs: {
      "header": "Fun and Engaging"
    }
  }, [_c('p', [_vm._v("The site targets children in elementary school to learn about robots.\n        Therefore the texts are easy to understand with fun animations and\n        a playful drawing for each topic to keep young readers interested.")]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "assets/projects/robots-and-ai/transition.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ff1e7eb"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/single/robots-and-ai.vue
// module id = 122
// module chunks = 0